module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURQAAAP///////////////////////////////////////////////////////////////7eV4oIAAAAQdFJOUwDhEyypWXPOR/GYsgYht4ukwhWkAAAAbElEQVQY02WPWQ7AIAhEwQ2Xarn/aQvaGIzz+cIsAGSiCFa5MBdvCbEoXSRYMpTQY0i9XFFN9gS6dI2jHYIc5XOQJrsDaXY7kNNJJMbYauwTeZwrX+lgXD/6OXwJf2PdpOzGVhYx830KhJjgAxC4Bedl+AJwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone-1.png
// module id = C/0e
// module chunks = 1